import { useEffect, useState } from 'react';
import UserApi from '../../rest-api/user-api';
import { toJS } from 'mobx';

const useFetchHandoutData = (contentStore, imageStore, linkId) => {
    const [error, setError] = useState(null);

    useEffect(() => {
        let isCancelled = false; // Flag to avoid state updates on unmounted components

        const fetchData = async () => {
            if (!contentStore.isInitialized || !imageStore.isInitialized) {
                console.log('useFetchHandoutData::contentStore or imageStore not initialized');
                return;
            }
            console.warn('useFetchedHandoutData before fetch ', toJS(contentStore.handoutData));

            // If contentStore already has the correct linkId and handoutData, no need to fetch
            if (contentStore.linkId === linkId && contentStore.handoutData) {
                console.log('useFetchHandoutData::content already present');
                return;
            }

            try {
                // Clear previous data if linkId has changed
                if (contentStore.linkId && contentStore.linkId !== linkId) {
                    await contentStore.clearStore();
                    await imageStore.clearStore();
                }

                const clinicType = process.env.REACT_APP_CETRA_CLINIC_TYPE === 'vet' ? 'vet' : 'physio';

                // fetch data from PateintContentLink table
                const fetchedHandoutData = await UserApi.getContent(linkId, clinicType, 'en-UK');

                if (!isCancelled && fetchedHandoutData.length > 0) {
                    const contentIds = fetchedHandoutData.map((handout) => handout.contentId);
                    await imageStore.setContentIds(contentIds);
                    await contentStore.updateContent(linkId, fetchedHandoutData);
                    console.warn('useFetchedHandoutData post fetch', toJS(contentStore.handoutData));
                }
            } catch (err) {
                if (!isCancelled) {
                    // Only update state if the component is still mounted
                    const apiMessage = err?.response?.data?.message;
                    const errMessage = err?.message;
                    const clinicType =
                        process.env.REACT_APP_CETRA_CLINIC_TYPE === 'vet' ? 'veterinarian' : 'physiotherapist';
                    const fallbackMessage = `Sorry, this handout is no longer available, or the link may have expired. Please contact your ${clinicType} if you still need the information.`;
                    setError(apiMessage || errMessage || fallbackMessage);
                    console.error('Handout fetch error:', err);
                }
            }
        };

        fetchData();

        // Cleanup function to set isCancelled flag on unmount
        return () => {
            isCancelled = true;
        };
    }, [linkId, contentStore, imageStore]); // Only re-run the effect if linkId or stores change

    return error;
};

export default useFetchHandoutData;
